import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <div className="navbar-links">
          <Link
            to="/"
            className={`nav-link${location.pathname === '/' ? ' nav-link--active' : ''}`}
          >
            Home
          </Link>
          <a
            href="https://talk.eye2voice.com"
            className="nav-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            App
          </a>
          <Link
            to="/about-us"
            className={`nav-link${location.pathname === '/about-us' ? ' nav-link--active' : ''}`}
          >
            About Us
          </Link>
          <Link
            to="/demo"
            className={`nav-link${location.pathname === '/demo' ? ' nav-link--active' : ''}`}
          >
            Demo
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className={`navbar-hamburger${menuOpen ? ' is-open' : ''}`}
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="navbar-mobile-menu" onClick={() => setMenuOpen(false)}>
          <Link to="/" className="nav-link">Home</Link>
          <a href="https://talk.eye2voice.com" className="nav-link" target="_blank" rel="noopener noreferrer">App</a>
          <Link to="/about-us" className="nav-link">About Us</Link>
          <Link to="/demo" className="nav-link">Demo</Link>
        </div>
      )}
    </nav>
  );
}
